
import React from 'react';

function LatestReleases({ releases, error, getCoinImage, formatDate }) {
  return (
    <div className="latest-releases">
      <h2>Latest Releases and Updates</h2>
      {error && <p>{error}</p>}
      {!error && releases.length === 0 && <p>Loading data...</p>}
      <div className="coin-slider-wrapper">
        <div className="coin-slider">
          <ul>
            {releases.map((release) => (
              <li key={release.id}>
                <a href={`/coin/${release.symbol}`}>
                  <img
                    src={getCoinImage(release.symbol)}
                    alt={release.symbol}
                    className="coin-image"
                  />
                </a>
                <p>{formatDate(release.published_at)}</p>
              </li>
            ))}
          </ul>
          <ul>
            {releases.map((release) => (
              <li key={release.id}>
                <a href={`/coin/${release.symbol}`}>
                  <img
                    src={getCoinImage(release.symbol)}
                    alt={release.symbol}
                    className="coin-image"
                  />
                </a>
                <p>{formatDate(release.published_at)}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default LatestReleases;
